export const SMALL_BREAKPOINT = 799.99;

export const Breakpoint = {
  Small: `@media screen and (max-width: ${SMALL_BREAKPOINT}px)`,
  SmallPlus: "@media screen and (min-width: 800px) and (max-width: 1080px)",
  Medium: "@media screen and (max-width: 1281px)", // Macbook Pro 13"
  MediumPlus: "@media screen and (min-width: 1281px) and (max-width: 1440px)",
  MaxRegular: "@media screen and (max-width: 1440px)",
  Regular: "@media screen and (min-width: 1440px) and (max-width: 1600px)", // Macbook Pro 15"
  Large: "@media screen and (min-width: 1600px)",
  XLarge: "@media screen and (min-width: 1920px)",
  XXLarge: "@media screen and (min-width: 2380px)",
} as const;
